export default __webpack_public_path__ + "static/media/menwear.be57f2fe.jfif";